module.exports = __webpack_public_path__ + "static/media/LightbulbIcon.1b8b4758.svg";